import { useAxiosModule } from '@/modules/_shared/axios'
import { AuthenticationLog, AuthenticationLogsResponse } from './types'

const { getFromApi } = useAxiosModule()

/* Get Authentication logs list */

export type GetAuthenticationLogsResponse = AuthenticationLogsResponse
export async function getAuthenticationLogsList (search = '', sortBy = 'id desc', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams()
    queryParams.set('search', search)
    queryParams.set('sort', sortBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const url = 'system_access/login-attempts?' + queryParams.toString()
    return getFromApi<GetAuthenticationLogsResponse>(url)
}

/* Get Authentication log */

export type GetAuthenticationLogResponse = AuthenticationLog
export async function getAuthenticationLog (id: string) {
    return getFromApi<GetAuthenticationLogResponse>(`system_access/login-attempt/${id}`)
}
